module.exports = __webpack_public_path__ + "img/لوزی2.6c188e0f.png";